/* ============
 * Mutation types for the account module
 * ============
 *
 * The mutation types that are available
 * on the auth module.
 */

export const SET_LIST = "SET_LIST";

export default {
    SET_LIST
};
